var map = {
	"./1.jpg": 2983,
	"./10.jpg": 1398,
	"./11.jpg": 8270,
	"./12.jpg": 5523,
	"./13.jpg": 1623,
	"./2.jpg": 442,
	"./3.jpg": 3205,
	"./4.jpg": 3665,
	"./5.jpg": 1905,
	"./6.jpg": 6829,
	"./7.jpg": 2695,
	"./8.jpg": 6413,
	"./9.jpg": 470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5292;